export default __webpack_public_path__ + "static/media/haccp.051bffc3.png";